import _clone from 'lodash/clone';
import _isNumber from 'lodash/isNumber';
import _extend from 'lodash/extend';

import inventoryUtils from 'utils/inventoryUtils';

function AddAdmissionGroupPaymentRequestsPanelCtrl($scope, $panelInstance, venue, date, admissionGroup, paymentRequest, colorService,
  admissionGroupService, alertService, sdkUtils, confirmationRequestService, modalService, mapperService) { //eslint-disable-line
  $scope.admissionGroup = admissionGroup;
  $scope.loading = false;
  $scope.venue = venue;
  $scope.venueBrandColors = $scope.venue.branding ? {
    primaryColor: $scope.venue.branding.primaryColor ? colorService.rgbToHex($scope.venue.branding.primaryColor.red, $scope.venue.branding.primaryColor.green, $scope.venue.branding.primaryColor.blue) : null //eslint-disable-line
  } : {};
  $scope.date = date;
  $scope.paymentRequest = paymentRequest;
  $scope.editMode = !!$scope.paymentRequest;
  $scope.addPaymentRequestForm = {
    // paymentAmountType: $scope.admissionGroup.type === 'TABLE' ? 'DEPOSIT' : 'FULL',
    paymentAmountType: 'FULL',
    paymentAmount: $scope.admissionGroup.minimumSpend,
    notifyOnComplete: true,
    quantity: $scope.admissionGroup.type === 'TABLE' ? 1 : $scope.admissionGroup.guestsExpected,
    fees: getDefaultFees(),
    tax: getDefaultTax(),
    tip: getDefaultTip(),
    userPaysProcessing: true
  };
  $scope.feesConfig = {};

  $scope.getPaymentRequestLink = function() {
    let link = $scope.paymentRequest.link;

    if ($scope.admissionGroup.attributionId) {
      link += `&attributionId=${$scope.admissionGroup.attributionId}`;
    }

    return link;
  };

  $scope.$watchGroup([
    'addPaymentRequestForm.price',
    'addPaymentRequestForm.paymentAmountType',
    'addPaymentRequestForm.paymentAmount',
    'addPaymentRequestForm.quantity',
    'addPaymentRequestForm.tax',
    'addPaymentRequestForm.tip',
    'addPaymentRequestForm.userPaysProcessing'
  ], () => {
    _calculateTotalAndFees();
  });

  $scope.$watch('inventoryForm.fees', () => {
    _calculateTotalAndFees();
  }, true);

  function _calculateTotalAndFees() {
    let paymentType;

    if ($scope.admissionGroup.type === 'TABLE') {
      if ($scope.addPaymentRequestForm.paymentAmountType === 'FULL') {
        paymentType = 'ADVANCE';
      }
      if ($scope.addPaymentRequestForm.paymentAmountType === 'DEPOSIT') {
        paymentType = 'ADVANCE_DEPOSIT';
      }
      if ($scope.addPaymentRequestForm.paymentAmountType === 'AUTH') {
        paymentType = 'VENUE';
      }
    }

    if ($scope.admissionGroup.type === 'TICKET') {
      paymentType = 'ADVANCE';
    }

    const inventoryData = mapperService.mapInventoryToApi({
      inventoryType: $scope.admissionGroup.type === 'TABLE' ? 'PACKAGE' : 'TICKET',
      price: paymentType === 'ADVANCE_DEPOSIT' ? $scope.admissionGroup.minimumSpend : $scope.addPaymentRequestForm.paymentAmount,
      tax: $scope.addPaymentRequestForm.tax,
      tip: $scope.addPaymentRequestForm.tip,
      fees: $scope.addPaymentRequestForm.fees,
      depositAmount: paymentType === 'ADVANCE_DEPOSIT' ? $scope.addPaymentRequestForm.paymentAmount : 0,
      paymentType,
      userPaysProcessing: $scope.addPaymentRequestForm.userPaysProcessing
    });

    const buyerData = inventoryUtils.buyerTotal({
      inventoryType: inventoryData.type,
      price: inventoryData.price,
      taxPercent: inventoryData.tax,
      tipPercent: inventoryData.tip,
      ticketProcessingFee: $scope.venue.ticketProcessingFee,
      tableProcessingFee: $scope.venue.tableProcessingFee,
      fees: inventoryData.fees,
      depositAmount: inventoryData.depositAmount,
      paymentType: inventoryData.paymentType,
      userPaysProcessing: $scope.addPaymentRequestForm.userPaysProcessing
    });

    $scope.buyerData = buyerData;
  }

  $scope.linkCopied = function(request, $event) {
    if (!request) return;
    if ($event) $event.preventDefault();

    request.showCopiedTooltip = true;
  };

  $scope.admissonGroupDescriptionOptions = {
    toolbar: [
      ['style', ['style']],
      ['style', ['bold', 'italic', 'underline']],
      ['fontsize', ['fontsize']],
      ['insert', ['link']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['height', ['height']]
    ],
    height: 140
  };

  $scope.createPaymentRequest = function(angularForm, $event) {
    if ($event) $event.preventDefault();

    $scope.submitted = true;

    if (!angularForm.$valid) return null;

    $scope.saving = true;

    const inventoryData = mapperService.mapInventoryToApi({
      inventoryType: $scope.admissionGroup.type === 'TABLE' ? 'PACKAGE' : 'TICKET',
      price: $scope.addPaymentRequestForm.paymentAmountType === 'ADVANCE_DEPOSIT' ? $scope.admissionGroup.minimumSpend : $scope.addPaymentRequestForm.paymentAmount,
      tax: $scope.addPaymentRequestForm.tax,
      tip: $scope.addPaymentRequestForm.tip,
      fees: $scope.addPaymentRequestForm.fees,
      depositAmount: $scope.addPaymentRequestForm.paymentAmountType === 'ADVANCE_DEPOSIT' ? $scope.addPaymentRequestForm.paymentAmount : 0,
      paymentType: $scope.addPaymentRequestForm.paymentAmountType,
      userPaysProcessing: $scope.addPaymentRequestForm.userPaysProcessing
    });

    console.log('inventoryData', inventoryData);

    return confirmationRequestService.createByAdmissionGroupId($scope.admissionGroup.id, _extend({
        name: $scope.addPaymentRequestForm.name,
        message: $scope.addPaymentRequestForm.message,
        paymentAmountType: $scope.addPaymentRequestForm.paymentAmountType,
        paymentAmount: $scope.addPaymentRequestForm.paymentAmountType === 'NONE' ? 0 : $scope.addPaymentRequestForm.paymentAmount,
        quantity: $scope.addPaymentRequestForm.quantity,
        notifyOnComplete: $scope.addPaymentRequestForm.notifyOnComplete
      }, inventoryData))
      .then(request => {
        $scope.saving = false;
        $scope.requestCreated = request;

        $scope.closePanel();
      })
      .catch(error => {
        $scope.saving = false;

        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  };

  $scope.cancelPaymentRequest = function($event) {
    if ($event) $event.preventDefault();

    modalService.confirmation({
        modalHeader: 'Cancel Payment Request',
        modalMessage: 'Are you sure you want to cancel this payment request?',
        confirmBtnTxt: 'Cancel Request',
        confirmingBtnTxt: 'Canceling...',
        size: 'sm'
      })
      .then(result => {
        if (result && result.confirm) {
          return confirmationRequestService.cancelById($scope.paymentRequest.id)
            .then(request => {
              $panelInstance.close({
                canceled: true,
                paymentRequest: request
              });

              $scope.saving = false;
            })
            .catch(error => {
              $scope.saving = false;

              alertService.error(sdkUtils.getErrorFromResponse(error));
            })
            .finally(() => {
              result.modalInstance.close();
            });
        }

        return null;
      })
      .catch(error => {
        console.log(error);
      });
  };

  $scope.sendConfirmationEmail = function($event) {
    if ($event) $event.preventDefault();

    modalService.confirmationPaymentRequest({
        email: $scope.admissionGroup.email,
        paymentRequest,
        size: 'sm'
      })
      .then(result => {
        if (result && result.confirm) {
          alertService.success('An email has been sent to your customer to confirm their reservation');
        }

        result.modalInstance.close();

        return null;
      })
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  };

  $scope.closePanel = function($event) {
    if ($event) $event.preventDefault();

    $panelInstance.close({
      paymentRequest: $scope.requestCreated
    });
  };

  function getDefaultFees() {
    if (($scope.admissionGroup.type === 'TICKET' || $scope.admissionGroup.type === 'COVER') && ($scope.venue.ticketFees && $scope.venue.ticketFees.length)) {
      const fees = $scope.venue.ticketFees.map(_clone);

      return fees.map(fee => {
        if (fee.type === 'PERCENT') {
          fee.amount = Number((fee.amount * 100).toFixed(2));
        }
        return fee;
      });
    }

    if (($scope.admissionGroup.type === 'TABLE' || $scope.admissionGroup.type === 'PACKAGE') && ($scope.venue.fees && $scope.venue.fees.length)) {
      const fees = $scope.venue.fees.map(_clone);

      return fees.map(fee => {
        if (fee.type === 'PERCENT') {
          fee.amount = Number((fee.amount * 100).toFixed(2));
        }
        return fee;
      });
    }

    return [];
  }

  function getDefaultTax() {
    if (($scope.admissionGroup.type === 'TICKET' || $scope.admissionGroup.type === 'COVER') && _isNumber($scope.venue.ticketTax)) {
      return Number(($scope.venue.ticketTax * 100).toFixed(4));
    } else if (($scope.admissionGroup.type === 'TABLE' || $scope.admissionGroup.type === 'PACKAGE') && _isNumber($scope.venue.tax)) {
      return Number(($scope.venue.tax * 100).toFixed(4));
    }

    return null;
  }

  function getDefaultTip() {
    if (($scope.admissionGroup.type === 'TABLE' || $scope.admissionGroup.type === 'PACKAGE') && _isNumber($scope.venue.tip)) return Number(($scope.venue.tip * 100).toFixed(2));

    return null;
  }
}

AddAdmissionGroupPaymentRequestsPanelCtrl.$inject = [
  '$scope',
  '$panelInstance',
  'venue',
  'date',
  'admissionGroup',
  'paymentRequest',
  'colorService',
  'jsSdk.admissionGroup',
  'alertService',
  'jsSdk.utils',
  'jsSdk.confirmationRequest',
  'modalService',
  'mapperService'
];

export default AddAdmissionGroupPaymentRequestsPanelCtrl;



// WEBPACK FOOTER //
// ./src/panels/addAdmissionGroupPaymentRequests/controller.js